module.exports = __webpack_public_path__ + "static/media/node js.ad41595e.png";